import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { CmsService, OccEndpointsService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { DataLayerService } from 'src/app/shared/services/data-layer.service';
import { RecaptchaService } from 'src/app/shared/services/recaptcha.service';
import { VaxContactusService } from '../vax-contactus.service';

@Component({
  selector: 'app-vax-contact-us',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './vax-contact-us.component.html',
  styleUrls: ['./vax-contact-us.component.scss'],
})
export class VaxContactUsComponent implements OnInit, OnDestroy {
  emailRegx = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,15}$/;
  contactusForm = this.fb.group(
    {
      name: new FormControl('', [
        Validators.required,
        Validators.pattern("^[a-zA-Z -']+"),
      ]),
      title: new FormControl(''),
      company: new FormControl(''),
      businessEmail: new FormControl('', [
        Validators.required,
        Validators.pattern(this.emailRegx),
      ]),
      confirmBusinessEmail: new FormControl('', [
        Validators.required,
        Validators.pattern(this.emailRegx),
      ]),
      phone: new FormControl(''),
      comments: new FormControl('', [Validators.maxLength(250)]),
      recaptchaReactive: new FormControl('', Validators.required),
    },
    {
      validator: (form: FormGroup) => {
        return form.get('businessEmail').value !==
          form.get('confirmBusinessEmail').value
          ? { emailMismatch: true }
          : null;
      },
    }
  );
  cmsResponse: any;
  baseUrl: any;
  type: string;
  imageUrl: any;
  redirectionLink: any;
  cmsSub: Subscription;
  contentSubscription: any;
  quickLinkContent: any;
  contentResp: any;
  successMessage: string;
  invaliadPhone: boolean;
  submitted: boolean;
  alphaCheck: boolean;
  isInputFocused: any = [false, false, false, false, false];
  captchaResp: string;
  vaxSub: Subscription;
  recaptchaEnabled = false;
  siteKey: string | null = null;
  subRecaptcha: Subscription;

  constructor(
    private readonly cmsData: CmsService,
    private readonly occEndPoint: OccEndpointsService,
    private readonly vaxContactService: VaxContactusService,
    private readonly fb: FormBuilder,
    private readonly ref: ChangeDetectorRef,
    private readonly _dataService: DataLayerService,
    private recaptchaService: RecaptchaService
  ) {
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
  }

  ngOnInit() {
    this.cmsSub = this.cmsData
      .getComponentData('CorporateOfficeBannerComponent')
      .subscribe((res) => {
        this.cmsResponse = res;
        if (this.cmsResponse) {
          this.imageUrl = this.cmsResponse?.media?.url
            ? this.validateDomainNameExistence(this.cmsResponse?.media?.url)
              ? this.cmsResponse.media.url
              : this.baseUrl + this.cmsResponse.media.url
            : '';
          if (this.cmsResponse?.media?.url) {
            this._dataService.addtoDataLayer(
              'view_promotion',
              this.cmsResponse
            );
          }
        }
      });
    this.subRecaptcha = this.recaptchaService.isEnabled$().subscribe((enabled) => {
      this.recaptchaEnabled = enabled;
      this.siteKey = this.recaptchaService.getSiteKey();
       if (!enabled) {
        this.contactusForm.get('recaptchaReactive')?.clearValidators();
        this.contactusForm.get('recaptchaReactive')?.updateValueAndValidity();
      }
    });
  }
  ngOnDestroy(): void {
    this.cmsSub?.unsubscribe();
    this.vaxSub?.unsubscribe();
    this.subRecaptcha?.unsubscribe();
  }

  formatPhoneNumber(event: any): void {
    const input = this.contactusForm.controls.phone.value;
    let value = input.replace(/\D/g, '');
    if (event.keyCode === 8) {
      return;
    }
    if (value.length >= 3 && value.length <= 6) {
      value = value.slice(0, 3) + '-' + value.slice(3);
      this.contactusForm.controls.phone.patchValue(value);
    } else if (value.length >= 7 && value.length <= 10) {
      value =
        value.slice(0, 3) + '-' + value.slice(3, 6) + '-' + value.slice(6);
      this.contactusForm.controls.phone.patchValue(value);
    }
  }

  Validate(e) {
    if (/[a-zA-Z]/g.test(e.target.value)) {
      this.alphaCheck = false;
    } else {
      this.alphaCheck = true;
    }
    this.ref.detectChanges();
    return this.alphaCheck;
  }

  onBlur(event: any): void {
    const inputElement = event.target as HTMLInputElement;
    const phoneNumber = inputElement.value;

    if (phoneNumber && phoneNumber.length < 10 && phoneNumber.length > 0) {
      // If the input is not empty and its length is less than 10, throw an error message
      this.invaliadPhone = true;
    } else {
      this.invaliadPhone = false;
    }
  }
  get isEmailMismatch() {
    return this.contactusForm.getError('emailMismatch');
  }
  fetchContactFormDetails() {
    this.submitted = true;
    this.contactusForm.markAllAsTouched();
    if (this.contactusForm.invalid) {
      return;
    }
    let params = this.contactusForm.value;
    this.vaxSub = this.vaxContactService
      .submitContactFormService(params)
      .subscribe(
        (data) => {
          this.successMessage =
            "Thank you for reaching out. We'll direct your message to the right person, and they'll contact you shortly.";
          this.submitted = false;
          this.contactusForm.reset();
          this.ref.detectChanges();
          //Clearing message after 5 secs
          setTimeout(() => {
            this.successMessage = '';
            this.ref.detectChanges();
          }, 5000);
        },
        (error) => {}
      );
  }
  validateDomainNameExistence(url: string) {
    return url.indexOf('https://') === 0 || url.indexOf('www.') === 0;
  }
  get f(): any {
    return this.contactusForm.controls;
  }
  resolved(captchaResponse: string) {
    this.captchaResp = captchaResponse;
  }
}
